import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { RootState } from '@root/app.state';
import { back } from '@platform/router.actions';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
  standalone: false,
})
export class UnauthorizedComponent implements OnInit {
  constructor(private store$: Store<RootState>) {}

  ngOnInit(): void {}

  public back(): void {
    this.store$.dispatch(back());
  }
}
